import { Menu, Button } from 'antd';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import { useEffect, useState } from 'react';
import { NavLink, useMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { first } from 'lodash-es';
import classnames from 'classnames';
import { useTheme } from 'styled-components';
import { useDependencies } from '../../../cross-cutting-concerns/dependency-injection/useDependencies';
import { StyledAppSider } from './AppSider.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export const AppSider = ({
  isCollapsed,
  onToggleCollapse,
}: {
  isCollapsed: boolean;
  onToggleCollapse: (val: boolean) => void;
}): JSX.Element => {
  const { t } = useTranslation();
  const routeMatch = useMatch('/:path/*');
  const { menuItemManager } = useDependencies();
  const [menuItems, setMenuItems] = useState<ItemType[]>([]);
  const theme = useTheme();

  useEffect(() => {
    const getMenuItemsAsync = async (): Promise<void> => {
      const items = await menuItemManager.getMenuItems();
      const preparedItems = items.map(item => ({
        label: <NavLink to={item.path}>{t(item.translationKey)}</NavLink>,
        key: item.path,
        icon: item.icon,
      }));

      setMenuItems(preparedItems);
    };
    getMenuItemsAsync();
  }, [menuItemManager, t, isCollapsed]);

  const firstMenuItem = first(menuItems);

  const getPathName = (): string => {
    if (routeMatch?.pathname.includes('machines/claim-pair')) {
      return routeMatch?.pathname as string;
    }
    return routeMatch?.pathnameBase as string;
  };

  const collapsedWidth = theme.constants?.sideBar?.width?.collapsed ?? 56;
  const fullWidth = theme.constants?.sideBar?.width?.full ?? 200;

  return (
    <StyledAppSider
      width={isCollapsed ? collapsedWidth : fullWidth}
      className={classnames('side-nav', {
        'side-nav--collapsed': isCollapsed,
      })}
    >
      <Menu selectedKeys={[getPathName() || (String(firstMenuItem?.key) ?? '')]} items={menuItems} />
      <Button
        className="side-nav__toggle"
        type="text"
        onClick={(): void => onToggleCollapse(!isCollapsed)}
        icon={<SvgIcon name="doubleChevronRight" />}
      />
    </StyledAppSider>
  );
};
